import { useGetByTenantAccountQuery } from 'api/rtk-api'
import { NoteDetailsTable } from 'components/core-v2/organisms/tables/note-details'
import { useParams } from 'react-router-dom'

import { TENANT } from '../../../const'

export const NoteDetailsTab = () => {
  const { noteId } = useParams()
  const { data, isLoading } = useGetByTenantAccountQuery({
    tenant: TENANT,
    noteIds: noteId
  })

  if (isLoading) return null

  const accountWithinTheNote = data.accounts.find(account => account.noteId === noteId)

  if (!accountWithinTheNote) return null

  return (
    <NoteDetailsTable
      accountId={accountWithinTheNote.accountId}
      accountSource={accountWithinTheNote.accountSource}
    />
  )
}
